import { CircularProgress, IconButton, Paper, TextField, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React, { useState } from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import { ICreateChatMessage } from '../../../../../../api/types/chat'
import { useGlobalError } from '../../../../../../context/GlobalError'
import { useMutation } from '@tanstack/react-query'
import { mutationCreateChatMessage } from '../../../../../../api/mutations'
import SendIcon from '@mui/icons-material/Send'
import { IGame } from '../../../../../../api/types/game'
import { extractMessage } from '../../../../../../utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
    },
    chatInputText: {
      width: '100%',
    },
    chatSendButton: {
      margin: '2px',
      padding: '2px',
    },
    root: {
      flex: '0 1',
      padding: '4px',
    },
  })
)

interface Props {
  game: IGame
}

export const ChatMessageInput: React.FC<Props> = ({ game }) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const [message, setMessage] = useState<string>('')

  const { mutate: postChatMessage, isLoading: isMutating } = useMutation(
    (newMessage: ICreateChatMessage) => mutationCreateChatMessage(newMessage),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się wysłać wiadomości', err?.status)
      },
      onSuccess: async () => {},
    }
  )

  const parseMessage = (msg: string): ICreateChatMessage => {
    msg = msg.trim()
    return {
      game: game.id,
      message: msg,
    }
  }

  const handlePostMessage = () => {
    const parsed = parseMessage(message)
    if (parsed.message?.length > 0) {
      postChatMessage(parsed)
      setMessage('')
    }
  }

  const handleChatMessageInput = (event: any) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && !event.shiftKey) {
      event.preventDefault()
      handlePostMessage()
    }
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.container}>
        <TextField
          variant={'standard'}
          multiline={true}
          className={classes.chatInputText}
          onKeyDown={handleChatMessageInput}
          onChange={e => setMessage(e.target.value)}
          value={message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isMutating && <CircularProgress size={20} />}
              </InputAdornment>
            ),
          }}
        />
        <IconButton size="small" className={classes.chatSendButton} onClick={handlePostMessage}>
          <SendIcon />
        </IconButton>
      </div>
    </Paper>
  )
}
